import { Component, OnInit, HostListener, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {
    @Input() public pageStrapline: string;
    @Input() public pageTitle: string;
    @ViewChild('pageTitleArea', { static: true }) public pageTitleArea: ElementRef;

    element: any;

    constructor() { }

    ngOnInit() {
        this.element = this.pageTitleArea.nativeElement;
    }

}
